module.exports = __webpack_public_path__ + "img/b44c625.jpg";